const apiConfig = {
  development: {
    baseURL: "https://beanstalk.myskillstree.com",
  },
  production: {
    baseURL: "https://prd.beanstalk.myskillstree.com",
  },
  staging: {
    baseURL: "https://beanstalk.stg.myskillstree.com",
  },
};
const DomainName = window.location.hostname;

export const getApiBaseURL = () => {
  const environment =
  ( DomainName === "localhost" || DomainName.includes("dev.") )? "development" 
  : DomainName.includes("stg.") ? "staging" :  "production";
  return apiConfig[environment].baseURL;
};

export const getEnvironment = () => {
  return DomainName.includes("dev.") || DomainName.includes("dev")
    ? "dev"
    : DomainName.includes("stg.")
    ? "stg"
    : DomainName === "localhost"
    ? "localhost"
    : "prod"; // Default to "prod"
};

export const urlMapping = {
  localhost: {
    bluecollar: "http://localhost:3004",
    whitecollar: "http://localhost:3003",
    hospitality: "http://localhost:3002",
    aijobs: "http://localhost:3001",
    internship: "http://localhost:3006",
    sbj: "http://localhost:3000",
  },
  dev: {
    bluecollar: "https://bluecollar.dev.skillsbasedjobs.global",
    whitecollar: "https://whitecollar.dev.skillsbasedjobs.global",
    hospitality: "https://hospitality.dev.skillsbasedjobs.global",
    aijobs: "https://aijobs.dev.skillsbasedjobs.global",
    internship: "https://internship.dev.skillsbasedjobs.global",
    sbj: "https://dev.skillsbasedjobs.global",
  },
  stg: {
    bluecollar: "https://bluecollar.stg.skillsbasedjobs.global",
    whitecollar: "https://whitecollar.stg.skillsbasedjobs.global",
    hospitality: "https://hospitality.stg.skillsbasedjobs.global",
    aijobs: "https://aijobs.stg.skillsbasedjobs.global",
    internship: "https://internship.stg.skillsbasedjobs.global",
    sbj: "https://stg.skillsbasedjobs.global",
  },
  prod: {
    bluecollar: "https://bluecollar.skillsbasedjobs.global",
    whitecollar: "https://whitecollar.skillsbasedjobs.global",
    hospitality: "https://hospitality.skillsbasedjobs.global",
    aijobs: "https://aijobs.skillsbasedjobs.global",
    sbj: "https://skillsbasedjobs.global",
    internship: "https://internship.skillsbasedjobs.global",
  },
};
// export const getApiBaseURL = () => {
//     const environment = 'staging';
//     return apiConfig[environment].baseURL;
// };
export const getRedirectPath = () => {
  let redirectPath = "";
  let domain = "";
  // Define an array of known production domains
  const prodDomains = [
    "bluecollar.skillsbasedjobs.global",
    "whitecollar.skillsbasedjobs.global",
    "hospitality.skillsbasedjobs.global",
    "aijobs.skillsbasedjobs.global",
    "skillsbasedjobs.global",
  ];

  if (prodDomains.some((prodDomain) => DomainName.includes(prodDomain))) {
    domain = "prod";
  }

  // Determine the redirect URL based on the environment
  if (DomainName.includes("dev.")) {
    redirectPath = "https://dev.myskillstree.com/skill-owner/email";
  } else if (DomainName.includes("stg.")) {
    redirectPath = "https://stg.myskillstree.com/skill-owner/email";
  } else if (DomainName.includes("localhost")) {
    redirectPath = "https://dev.myskillstree.com/skill-owner/email";
    redirectPath = "https://dev.myskillstree.com/skill-owner/email";
  } else if (domain === "prod") {
    // redirectPath = "https://owners.skillsbasedjobs.global";
    redirectPath = "https://myskillstree.com/skill-owner/email";

  }
  return redirectPath;
}
